import { Card, CardContent, CardFooter, CardHeader } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';
import { useUserStore } from '@/stores/userStore';

/** 开户申请代码加载时保留当前 TikTok 平台卡片，并按现有权限预留申请入口 */
export function AccountApplicationSkeleton() {
  const permissionCodes = useUserStore((state) => state.userInfo?.permissionCodes);
  const canApply = permissionCodes?.includes('business:account_application:create');

  return (
    <div
      className="*:data-[slot=card]:from-primary/5 *:data-[slot=card]:to-card dark:*:data-[slot=card]:bg-card grid grid-cols-4 gap-4 *:data-[slot=card]:bg-linear-to-t *:data-[slot=card]:shadow-xs @xl/main:grid-cols-2 @5xl/main:grid-cols-4 min-w-400"
      aria-hidden="true"
    >
      <Card className="@container/card">
        {/** 平台图标和名称 */}
        <CardHeader>
          <div className="flex gap-2">
            <Skeleton className="h-4 w-4" />
            <Skeleton className="h-4 w-14" />
          </div>
        </CardHeader>
        {/** 四段说明按当前卡片的 3／2／2／1 行占位，宽卡片减少换行 */}
        <CardContent>
          {[3, 2, 2, 1].map((lineCount, paragraphIndex) => (
            <div key={paragraphIndex}>
              {Array.from({ length: lineCount }, (_, lineIndex) => (
                <div
                  key={lineIndex}
                  className={cn(
                    'h-5',
                    lineIndex >= (paragraphIndex === 0 ? 2 : 1) && '@[500px]/card:hidden'
                  )}
                >
                  <Skeleton className={cn('h-4', lineIndex === lineCount - 1 ? 'w-4/5' : 'w-full')} />
                </div>
              ))}
            </div>
          ))}
        </CardContent>
        {/** 申请按钮沿用页面权限，保留原卡片底部容器 */}
        <CardFooter>{canApply && <Skeleton className="h-9 w-full" />}</CardFooter>
      </Card>
    </div>
  );
}
